import {
    faQuestionCircle,
    faStopwatch,
    faLightbulb,
    faHandPointUp,
    faEdit,
} from "../../assets/consts/faCharCodes";
import { getIconByDeviceType } from "./DeviceHelper";
export const getScenarioIconByMainCondition = (mainCondition) => {
    let icon = faQuestionCircle;
    if (mainCondition) {
        switch (mainCondition.baseType) {
            case "schedule":
                icon = faStopwatch;
                break;
            case "device":
                var type =
                    mainCondition.deviceType ||
                    mainCondition.listenerName?.replace("Listener", "")?.toUpperCase();
                icon = getIconByDeviceType(type) || faLightbulb;
                break;
            case "virtual":
                icon = mainCondition.iconName || faHandPointUp;
                break;
        }
    }
    return icon;

}